import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isVdMartLocation } from '../utils/vdMartPOS';
import { clearCart, setBuyer, addToCart, cancelBuyer } from '../features/cart/cartSlice';
import { API_BASE_URL } from '../utils/apiConfig';


export default function VdMartBuyerGate() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.posUser.userInfo);
  const buyer = useSelector(state => state.cart.buyer);
  const requested = useSelector(state => state.cart.buyerSelectionRequested);
  const pendingProduct = useSelector(state => state.cart.pendingProduct);
  const [type, setType] = useState('retail');
  const [error, setError] = useState('');
  const [outletQuery, setOutletQuery] = useState('');
  const [outlets, setOutlets] = useState([]);
  const [outlet, setOutlet] = useState(null);
  useEffect(() => {
    if (requested) { setOutlet(null); setOutletQuery(''); setOutlets([]); }
  }, [requested]);
  useEffect(() => {
    setOutlets([]);
    if (!requested || type !== 'outlet' || outlet || outletQuery.trim().length < 2) return;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/orders/pos/catalog-outlets?q=${encodeURIComponent(outletQuery.trim())}`, { headers: { Authorization: `Bearer ${user?.token}` }, signal: controller.signal });
        const data = await response.json();
        if (!response.ok) {
          if (data.message === 'Invalid order identifier') throw new Error('The backend has not loaded outlet search yet. Restart the backend, then search again.');
          throw new Error(data.message || 'Unable to load outlets.');
        }
        if (!controller.signal.aborted) { setOutlets(data.outlets || []); setError(data.outlets?.length ? '' : 'No matching destination outlet.'); }
      } catch (err) { if (!controller.signal.aborted) setError(err.message); }
    }, 250);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [requested, type, outletQuery, outlet, user?.token]);
  useEffect(() => { if (requested) { setType(buyer?.billingMode === 'retail' ? 'retail' : buyer?.stakeholderType || 'retail'); setError(''); } }, [requested, buyer]);
  if (!isVdMartLocation(user?.location)) return null;
  if (!requested) return null;
  const start = event => {
    event.preventDefault(); setError('');
    try {
      if (type === 'outlet' && !outlet) throw new Error('Search and select the destination outlet.');
      const value = { stakeholderType: type === 'retail' ? 'customer' : type, stakeholderId: type === 'outlet' ? outlet.id : null,
        ...(['retail', 'customer'].includes(type) ? { billingMode: type === 'retail' ? 'retail' : 'franchise' } : {}),
        ...(type === 'outlet' ? { name: outlet.name, destinationOutletLocation: outlet.name } : {}) };
      dispatch(clearCart());
      dispatch(setBuyer({ ...value, location: user.location, orderId: Date.now() * 100 + Math.floor(Math.random() * 100) }));
      if (pendingProduct) dispatch(addToCart(pendingProduct));
      dispatch(cancelBuyer());
    } catch (e) { setError(e.message || String(e)); }
  };
  return <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50">
    <form onSubmit={start} className="bg-white rounded-lg p-6 w-96 space-y-4">
      <h2 className="text-xl font-semibold">Start Vadaparru order</h2>
      <label className="block">Stakeholder<select className="block border rounded p-2 w-full" value={type} onChange={e => setType(e.target.value)}>
        <option value="customer">Franchise customer — stakeholder</option><option value="retail">Customer billing — this outlet</option><option value="vendor">Vendor</option><option value="outlet">Outlet — dispatch to another outlet</option><option value="internal_packing">Internal packing</option>
      </select></label>
      {type === 'outlet' ? <div>
        <label className="block">Destination outlet<input value={outletQuery} onChange={e => { setOutletQuery(e.target.value); setOutlet(null); setError(''); }} placeholder="Search outlet name" className="block w-full rounded border p-2" /></label>
        <div className="max-h-40 overflow-auto">{outlets.map(row => <button key={row.id} type="button" className="block w-full border-b p-2 text-left hover:bg-blue-50" onClick={() => { setOutlet(row); setOutletQuery(row.name); setOutlets([]); setError(''); }}>{row.name}</button>)}</div>
        <p className="text-xs text-gray-600">Creating this order transfers stock to the selected outlet.</p>
      </div> : type === 'retail' ? <p className="text-xs text-gray-600">Bill a retail customer using this outlet’s pricing. No stock is transferred to another outlet.</p> : type === 'customer' && <p className="text-xs text-gray-600">Bill a registered franchise customer using stakeholder customer pricing. Their mobile is checked at payment.</p>}
      {error && <p role="alert" className="text-red-600">{error}</p>}
      <button className="bg-green-700 text-white rounded p-2 w-full">{pendingProduct ? 'Add item' : 'Select stakeholder'}</button>
      <button type="button" onClick={() => dispatch(cancelBuyer())}>Cancel</button>
    </form>
  </div>;
}
